<div class="align-center">
    <div>
        <section class="login-page">
            <h1>Welcome!</h1>
            <p>Sign in with your Microsoft account to continue.</p>
            <button class="primaryBtn" type="button" (click)="signIn()">Sign in with Microsoft</button>
        </section>
    </div>
</div>